var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2442 18.4972C17.6584 18.4972 17.9942 18.833 17.9942 19.2472C17.9942 19.6269 17.712 19.9407 17.3459 19.9904L17.2442 19.9972H6.74951C6.3353 19.9972 5.99951 19.6614 5.99951 19.2472C5.99951 18.8675 6.28167 18.5537 6.64774 18.5041L6.74951 18.4972H17.2442ZM12.0031 3.99902C12.3828 3.99902 12.6966 4.28118 12.7463 4.64725L12.7531 4.74902L12.7525 14.942L15.7187 11.9714C15.9848 11.7049 16.4014 11.6803 16.6952 11.8979L16.7794 11.9705C17.0459 12.2365 17.0705 12.6531 16.8529 12.9469L16.7804 13.0311L12.5375 17.2818L12.4669 17.3443L12.3759 17.4029L12.3395 17.424L12.2483 17.462L12.1278 17.4921L12.0586 17.5L11.9985 17.5019C11.9484 17.5019 11.8975 17.4964 11.8478 17.4859L11.7669 17.4627C11.6709 17.4317 11.5838 17.3815 11.5096 17.3167L7.22007 13.032C6.92697 12.7393 6.92663 12.2644 7.21932 11.9713C7.48539 11.7049 7.90204 11.6804 8.19581 11.898L8.27998 11.9706L11.2525 14.938L11.2531 4.74902C11.2531 4.33481 11.5889 3.99902 12.0031 3.99902Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.01609ef4aad59a2d943d9d3873ccd90d.svg";
export { ForwardRef as ReactComponent };